export default __webpack_public_path__ + "static/media/Conversation.2f96a794.svg";